import moment from 'moment'

// Same 30-day "close to expiry" window as MOT / insurance / LOLER.
export const FUEL_CARD_DUE_SOON_DAYS = 30

export const fuelCardState = (card) => {
  if (card?.cancelled) return 'cancelled'
  if (!card?.expiry) return 'ok'
  const expiry = moment(card.expiry)
  if (expiry.isBefore(moment())) return 'expired'
  // By day: expiry is stored as 23:59 on the month's last day, so a time
  // comparison would miss a card expiring exactly 30 days out
  if (expiry.isSameOrBefore(moment().add(FUEL_CARD_DUE_SOON_DAYS, 'days'), 'day')) {
    return 'expiringSoon'
  }
  return 'ok'
}

export const FUEL_CARD_STATE = {
  ok: { label: 'In date', tone: 'success' },
  expiringSoon: { label: 'Expires soon', tone: 'warning' },
  expired: { label: 'Expired', tone: 'error' },
  cancelled: { label: 'Cancelled', tone: 'default' },
}

// Worst state across the vehicle's live cards - drives the Fuel tab badge.
// Null when every card is in date (or there are none).
export const fuelCardsAlert = (cards = []) => {
  const states = cards.map(fuelCardState)
  if (states.includes('expired')) return 'expired'
  if (states.includes('expiringSoon')) return 'expiringSoon'
  return null
}

export const maskCardNumber = (cardNumber = '') =>
  cardNumber.length <= 4 ? cardNumber : `•••• ${cardNumber.slice(-4)}`

// 1234567890123456 → 1234 5678 9012 3456
export const groupCardNumber = (cardNumber = '') =>
  cardNumber.replace(/(.{4})(?=.)/g, '$1 ')
